import { FC, useState } from 'react';

import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIProdcutDetailAllProductTable } from './components';

import { Grid, Box, Typography, Button, alpha } from '@mui/material';
import LayersIcon from '@mui/icons-material/Layers';
import SearchIcon from '@mui/icons-material/Search';
import SyncIcon from '@mui/icons-material/Sync';
import RefreshIcon from '@mui/icons-material/Refresh';
import { SearchServiceCommand } from '../../services/command';
import { SCUIContent } from '../../atomic/organisms';
import { SCUIBreadCrumb, SCUITextFieldWithButton } from '../../atomic/molecules';
import { SCUINoRecordComponent } from '../../atomic/atoms';

import { SearchServiceQuery } from '../../services/query';
import { Demo } from './components/ProductDetailSerachTable';
import { DSS } from './detailStockSearch.classes';

export const DetailStockSearch: FC<any> = () => {
    const { t } = useTranslation();

    const [orderNo, setOrderNo] = useState('');
    const [datas, setDatas] = useState<any>();
    const productEnv = JSON.parse(import.meta.env.VITE_PRODUCT_DICTIONARY!);

    const GetProductDetailAll = async () => {
        let params: any = {};
        params.optionId = String(orderNo);
        params.regionId = JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId?.toString();
        params.warehouseGroupId = productEnv[0].WarehouseGroupId;
        params.cultureCode = productEnv[0].CultureCode;
        if (params) {
            SearchServiceQuery.GetProductDetailAll(params).then((res: any) => {
                setDatas(res);
            });
        }
    };
    const GetStockByProduct = async () => {
        let params: any = {
            optionId: String(orderNo),
        };
        SearchServiceCommand.GetStockByProduct(params)
            .then((res: any) => {
                Swal.fire(res, ' ', 'success');
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'error');
                console.log('Hata :>> ', error);
            });
    };
    const InventoryLastSync = async () => {
        let params: any = {
            optionId: orderNo,
            WarehouseGroupId: 1,
        };
        SearchServiceCommand.UpdateLastSync(params)
            .then((res: any) => {
                console.info(res);
                Swal.fire(res + '', '');
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'warning');
                console.log('Hata :>> ', error);
            });
    };

    const listele = async () => {
        GetProductDetailAll();
    };

    return (
        <SCUIContent>
            <Grid className={DSS.page} container direction="row" spacing={2} sx={{ marginLeft: '0.5rem' }}>
                <SCUIBreadCrumb title={t('searchService.detailedStockSearch')} componentLink={'detailStockSearch'} />
                <Grid
                    className={DSS.searchFieldWrap}
                    sx={{ marginBottom: '2rem' }}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 7,
                        xl: 7,
                    }}
                >
                    <SCUITextFieldWithButton
                        placeholder={t('searchService.optionId')}
                        onChange={(event: any) => {
                            setOrderNo(event.target.value);
                        }}
                        onClick={() => listele()}
                        onKeyPress={(e: any) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                listele();
                                setOrderNo(e.target.value);
                            }
                        }}
                    />
                </Grid>
                {datas ? (
                    <Grid className={DSS.resultsSection} container direction="row" sx={{ marginLeft: '0.5rem' }}>
                        <Box
                            className={DSS.resultsToolbar}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                gap: 1.5,
                                width: '100%',
                                mb: 2,
                            }}
                        >
                            {/* Section title */}
                            <Box className={DSS.resultsTitleCluster} sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                <Box
                                    sx={{
                                        width: 4,
                                        height: 22,
                                        borderRadius: 2,
                                        background: 'linear-gradient(180deg, #6366f1 0%, #4f46e5 100%)',
                                        flexShrink: 0,
                                    }}
                                />
                                <SearchIcon sx={{ fontSize: 20, color: '#6366f1' }} />
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: '0.95rem',
                                        color: 'text.primary',
                                        letterSpacing: '-0.01em',
                                    }}
                                >
                                    {t('general.searchResults')}
                                </Typography>
                            </Box>

                            {/* Action buttons */}
                            {JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId === 1 && (
                                <Box className={DSS.resultsActions} sx={{ display: 'flex', gap: 1 }}>
                                    <Button
                                        className={DSS.inputButtonGetStock}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<SyncIcon sx={{ fontSize: '16px !important' }} />}
                                        onClick={() => GetStockByProduct()}
                                        sx={{
                                            borderColor: '#6366f1',
                                            color: '#6366f1',
                                            fontWeight: 600,
                                            fontSize: '0.8rem',
                                            padding: '8px 16px !important',
                                            borderRadius: 2,
                                            textTransform: 'none',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                bgcolor: alpha('#6366f1', 0.08),
                                                borderColor: '#4f46e5',
                                                boxShadow: `0 2px 10px ${alpha('#6366f1', 0.25)}`,
                                                transform: 'translateY(-1px)',
                                            },
                                        }}
                                    >
                                        {t('searchService.GetStock')}
                                    </Button>
                                    <Button
                                        className={DSS.inputButtonUpdateInventory}
                                        variant="contained"
                                        size="small"
                                        startIcon={<RefreshIcon sx={{ fontSize: '16px !important' }} />}
                                        onClick={() => InventoryLastSync()}
                                        sx={{
                                            background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                                            color: 'white',
                                            fontWeight: 600,
                                            fontSize: '0.8rem',
                                            padding: '8px 16px !important',
                                            borderRadius: 2,
                                            textTransform: 'none',
                                            boxShadow: `0 2px 8px ${alpha('#6366f1', 0.3)}`,
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                background: 'linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)',
                                                boxShadow: `0 4px 14px ${alpha('#6366f1', 0.4)}`,
                                                transform: 'translateY(-1px)',
                                            },
                                        }}
                                    >
                                        {t('searchService.UpdateInventory')}
                                    </Button>
                                </Box>
                            )}
                        </Box>
                        <Grid
                            className={DSS.productSummaryWrap}
                            sx={{ marginBottom: '1rem' }}
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIProdcutDetailAllProductTable datas={datas} />
                        </Grid>
                        <Box className={DSS.stockSectionHeader} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mt: 2.5, mb: 1.5, width: '100%' }}>
                            <Box
                                sx={{
                                    width: 4,
                                    height: 22,
                                    borderRadius: 2,
                                    background: 'linear-gradient(180deg, #6366f1 0%, #4f46e5 100%)',
                                    flexShrink: 0,
                                }}
                            />
                            <LayersIcon sx={{ fontSize: 20, color: '#6366f1' }} />
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '0.95rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                }}
                            >
                                {t('general.stockInformation')}
                            </Typography>
                        </Box>
                        <Grid
                            className={DSS.stockTableWrap}
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <Demo datas={datas} />
                        </Grid>
                    </Grid>
                ) : (
                    <Grid
                        className={DSS.emptyStateWrap}
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <SCUINoRecordComponent />
                    </Grid>
                )}
            </Grid>
        </SCUIContent>
    );
};
